import { createStore } from 'satcheljs';
export default createStore('domainOption', {
    isDomainCreated: false,
    isValid: false,
    domainName: '',
    isRemovingDomain: false,
    isDomainRemoved: false,
    isProsumerConsumerMailbox: false,
    isValidatingDomain: false,
    domainPurchaseDate: null,
})();
//# sourceMappingURL=store.js.map